if (!customElements.get('custom-featured-quote')) {
  customElements.define(
    'custom-featured-quote',
    class CustomFeaturedQuote extends HTMLElement {
      connectedCallback() {
        this.quoteBlock = this.querySelector('[data-quote-block]');
        this.quoteText = this.querySelector('[data-quote-text]');
        this.sourceText = this.querySelector('[data-source-text]');
        this.buttons = Array.from(this.querySelectorAll('[data-quote-button]'));
        this.animationTimeout = null;

        this.content = this.querySelector('.custom-featured-quote__content');
        this.onButtonClick = this.onButtonClick.bind(this);
        this.buttons.forEach((button) => button.addEventListener('click', this.onButtonClick));
        this.updateQuoteBlockVisibility(
          this.quoteText?.textContent?.trim() || '',
          this.sourceText?.hidden ? '' : this.sourceText?.textContent?.trim() || ''
        );
      }

      disconnectedCallback() {
        this.buttons.forEach((button) => button.removeEventListener('click', this.onButtonClick));
        window.clearTimeout(this.animationTimeout);
      }

      onButtonClick(event) {
        const button = event.currentTarget;
        const quote = button.getAttribute('data-quote') || '';
        const source = button.getAttribute('data-source') || '';

        if (!this.quoteText || !quote || button.classList.contains('is-active')) return;

        this.buttons.forEach((item) => {
          const isActive = item === button;
          item.classList.toggle('is-active', isActive);
          item.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        });

        this.quoteBlock.classList.add('is-changing');
        window.clearTimeout(this.animationTimeout);

        this.animationTimeout = window.setTimeout(() => {
          this.quoteText.textContent = quote;

          if (this.sourceText) {
            this.sourceText.textContent = source;
            this.sourceText.hidden = !source;
          }

          this.updateQuoteBlockVisibility(quote, source);
          this.quoteBlock.classList.remove('is-changing');
        }, 180);
      }

      updateQuoteBlockVisibility(quote, source) {
        if (!this.quoteBlock) return;

        const hasQuote = Boolean(quote?.trim() || source?.trim());
        this.quoteBlock.hidden = !hasQuote;
        this.content?.classList.toggle('custom-featured-quote__content--no-quote', !hasQuote);
      }
    }
  );
}
